import { Leaf } from "lucide-react";

/**
 * Cultiv wordmark — a small botanical leaf mark above the serif "CULTIV" wordmark.
 * The old `EdenWordmark` name is preserved as an alias for import compatibility.
 */
export const CultivWordmark = ({ size = "md", tone = "auto", className = "" }) => {
    const dims = {
        sm: { mark: "w-4 h-4", type: "text-lg tracking-[0.35em]" },
        md: { mark: "w-5 h-5", type: "text-2xl tracking-[0.35em]" },
        lg: { mark: "w-6 h-6", type: "text-3xl tracking-[0.4em]" },
        xl: { mark: "w-10 h-10", type: "text-6xl md:text-7xl tracking-[0.28em]" },
    }[size] || { mark: "w-5 h-5", type: "text-2xl tracking-[0.35em]" };
    const color =
        tone === "cream" ? "text-[hsl(var(--eden-cream))]" :
        tone === "forest" ? "text-[hsl(var(--eden-forest))]" : "";
    return (
        <div className={`inline-flex flex-col items-center ${color} ${className}`}>
            <Leaf className={`${dims.mark} text-[hsl(var(--eden-gold))]`} strokeWidth={1.1} />
            <div className={`font-serif ${dims.type} mt-1 leading-none`} style={{ fontWeight: 500 }}>CULTIV</div>
        </div>
    );
};

export const CultivMark = ({ className = "" }) => (
    <Leaf className={`text-[hsl(var(--eden-gold))] ${className}`} strokeWidth={1.1} />
);

// Back-compat aliases so existing imports keep working
export const EdenWordmark = CultivWordmark;
export const EdenMark = CultivMark;

export default CultivWordmark;
